import { DeliveryCode, DeliveryCodeCarrierMap } from "@/models/DeliveryCode";

const MANUAL_PREFIX = "Manual ";

// Shipment.ShipmentType is a free-form column: DeliveryCode member names, "Will-Call",
// "Streamline", partner carrier strings. Only the member names are remapped.
const displayNameByMemberName: Record<string, string> = Object.fromEntries(
    Object.keys(DeliveryCode)
        .filter(key => isNaN(Number(key)))
        .map(name => [
            name.toLowerCase(),
            DeliveryCodeCarrierMap[DeliveryCode[name as keyof typeof DeliveryCode]].displayName,
        ])
);

export function shipmentTypeLabel(shipmentType: string | null | undefined): string {
    if (!shipmentType) return "";

    const isManual = shipmentType.startsWith(MANUAL_PREFIX);
    const bare = isManual ? shipmentType.slice(MANUAL_PREFIX.length) : shipmentType;
    const displayName = displayNameByMemberName[bare.trim().toLowerCase()];

    if (!displayName) return shipmentType;
    return isManual ? MANUAL_PREFIX + displayName : displayName;
}
